import React from 'react';
import { Outlet } from 'react-router-dom';
import { Footer } from './footer/Footer';
import { MegaMenu } from './header/MegaMenu';
import { ScrollToTop } from './ScrollToTop';

/** 헤더 + 본문 + 푸터 기본 라우트 레이아웃. 본문이 짧으면 푸터를 화면 맨 아래로 밀어냄 */
export const RootLayout = () => {
  return (
    <div className="flex min-h-lvh flex-col">
      <MegaMenu />
      <main className="mt-[58px] flex-1">
        <ScrollToTop>
          <Outlet />
        </ScrollToTop>
      </main>
      <Footer />
    </div>
  );
};
